<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/weld2.png')"
      >
      </parallax>
      <div class="container">
        <h2 class="title mt-5">{{ $t('common.offices.productServices') }}</h2>
      </div>
    </div>
    <div class="section">
      <div class="container">

        <div class="row mt-5">
          <div class="col-md-10 col-xl-6 text-center">
            <div class="row">
              <div class="col-md-10 col-xl-6">
                <img
                  src="img/vessel1.png"
                  :alt="$t('product.categories.vessel')"
                  class="rounded animated fadeInDown"
                  width="100%"
                  height="87%"
                />
              </div>
              <div class="col-md-10 col-xl-6 card text-center ml-n3 cards">
                <router-link to="/detail-product-vessel">
                  <h5 class="mt-5 text-dark">{{ $t('product.fabricationOf') }} </h5> <br> <h2><span style="color: green;" class="font-weight-bold">{{ $t('product.categories.vessel') }}</span></h2><br>
                  <!-- <p class="mt-5 text-dark">There are some reason build the site lorem ipsum dolor sit amet.</p> -->
                  <!-- <h6 style="color: orange; margin-top: 70px; margin-bottom: 38px;">READ MORE</h6> -->
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-10 col-xl-6 text-center">
            <div class="row">
              <div class="col-md-10 col-xl-6">
                <img
                  src="img/he_service.png"
                  :alt="$t('product.categories.heatExchanger')"
                  class="rounded animated fadeInDown"
                  width="100%"
                  height="85%"
                />
              </div>
              <div class="col-md-10 col-xl-6 card text-center ml-n3 cards">
                <router-link to="/detail-product-he">
                 <h5 class="mt-4 text-dark">{{ $t('product.fabricationOf') }} </h5><br> <h2><span style="color: green;" class="font-weight-bold">{{ $t('product.categories.heatExchanger') }}</span></h2>
                 <!-- <p class="mt-4 text-dark">There are some reason build the site lorem ipsum dolor sit amet.</p> -->
                 <!-- <h6 style="color: orange; margin-top: 67px; margin-bottom: 38px;">READ MORE</h6> -->
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-10 col-xl-6 text-center">
            <div class="row">
              <div class="col-md-10 col-xl-6">
                <img
                  src="img/detail_product/piping/Titanium Gr. 2 Spool Piping (4).jpg"
                  :alt="$t('product.categories.piping')"
                  class="rounded animated fadeInDown"
                  width="100%"
                  height="87%"
                />
              </div>
              <div class="col-md-10 col-xl-6 card text-center ml-n3 cards">
                <router-link to="/detail-product-piping">
                  <h5 class="mt-5 text-dark">{{ $t('product.fabricationOf') }} </h5> <br> <h2><span style="color: green;" class="font-weight-bold">{{ $t('product.categories.piping') }}</span></h2><br>
                  <!-- <p class="mt-5 text-dark">There are some reason build the site lorem ipsum dolor sit amet.</p> -->
                  <!-- <h6 style="color: orange; margin-top: 70px; margin-bottom: 38px;">READ MORE</h6> -->
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-10 col-xl-6 text-center">
            <div class="row">
              <div class="col-md-10 col-xl-6">
                <img
                  src="img/detail_product/tower/Ni201 N02201 Distillation Column (2).jpg"
                  :alt="$t('product.categories.tower')"
                  class="rounded animated fadeInDown"
                  width="100%"
                  height="87%"
                />
              </div>
              <div class="col-md-10 col-xl-6 card text-center ml-n3 cards">
                <router-link to="/detail-product-tower">
                  <h5 class="mt-5 text-dark">{{ $t('product.fabricationOf') }} </h5> <br> <h2><span style="color: green;" class="font-weight-bold">{{ $t('product.categories.tower') }}</span></h2><br>
                  <!-- <p class="mt-5 text-dark">There are some reason build the site lorem ipsum dolor sit amet.</p> -->
                  <!-- <h6 style="color: orange; margin-top: 70px; margin-bottom: 38px;">READ MORE</h6> -->
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-10 col-xl-6 text-center">
            <div class="row">
              <div class="col-md-10 col-xl-6">
                <img
                  src="img/radiant_product.png"
                  :alt="$t('product.categories.radiantTube')"
                  class="rounded animated fadeInDown"
                  width="100%"
                  height="87%"
                />
              </div>
              <div class="col-md-10 col-xl-6 card text-center ml-n3 cards">
                <router-link to="/detail-product-radiant">
                  <h5 class="mt-5 text-dark">{{ $t('product.fabricationOf') }} </h5> <br> <h2><span style="color: green;" class="font-weight-bold">{{ $t('product.categories.radiantTube') }}</span></h2><br>
                  <!-- <p class="mt-5 text-dark">There are some reason build the site lorem ipsum dolor sit amet.</p> -->
                  <!-- <h6 style="color: orange; margin-top: 70px; margin-bottom: 38px;">READ MORE</h6> -->
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-10 col-xl-6 text-center">
            <div class="row">
              <div class="col-md-10 col-xl-6">
                <img
                  src="img/detail_product/muffle/MA23 Muffle.jpg"
                  :alt="$t('product.categories.muffle')"
                  class="rounded animated fadeInDown"
                  width="100%"
                  height="87%"
                />
              </div>
              <div class="col-md-10 col-xl-6 card text-center ml-n3 cards">
                <router-link to="/detail-product-mufle">
                  <h5 class="mt-5 text-dark">{{ $t('product.fabricationOf') }} </h5> <br> <h2><span style="color: green;" class="font-weight-bold">{{ $t('product.categories.muffle') }}</span></h2><br>
                  <!-- <p class="mt-5 text-dark">There are some reason build the site lorem ipsum dolor sit amet.</p> -->
                  <!-- <h6 style="color: orange; margin-top: 70px; margin-bottom: 38px;">READ MORE</h6> -->
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <!-- <div class="col-md-10 col-xl-6 text-center">
            <div class="row">
              <div class="col-md-10 col-xl-6">
                <img
                  src="img/radiant_product.png"
                  :alt="$t('product.categories.radiantTube')"
                  class="rounded animated fadeInDown"
                  width="100%"
                  height="87%"
                />
              </div>
              <div class="col-md-10 col-xl-6 card text-center ml-n3 cards">
                <router-link to="/detail-product-radiant">
                  <h5 class="mt-5 text-dark">Fabrication of </h5> <br> <h2><span style="color: green;" class="font-weight-bold">Radiant Tube</span></h2><br>
                </router-link>
              </div>
            </div>
          </div> -->
          <div class="col-md-10 col-xl-6 text-center">
            <div class="row">
              <div class="col-md-10 col-xl-6">
                <img
                  src="img/detail_product/other/Duplex Stainless Steel Screw Conveyor.png"
                  :alt="$t('product.categories.otherEquipment')"
                  class="rounded animated fadeInDown"
                  width="100%"
                  height="87%"
                />
              </div>
              <div class="col-md-10 col-xl-6 card text-center ml-n3 cards">
                <router-link to="/detail-product-other">
                  <h5 class="mt-5 text-dark">{{ $t('product.fabricationOf') }} </h5> <br> <h2><span style="color: green;" class="font-weight-bold">{{ $t('product.categories.otherEquipment') }}</span></h2>
                  <!-- <p class="mt-5 text-dark">There are some reason build the site lorem ipsum dolor sit amet.</p> -->
                  <!-- <h6 style="color: orange; margin-top: 70px; margin-bottom: 38px;">READ MORE</h6> -->
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-10 col-xl-12 text-center"> -->
            <div class="row mt-5">
              <div class="col-md-10 col-xl-4">
                <img
                  src="img/maintenance.png"
                  :alt="$t('product.onSiteServices.heading')"
                  class="rounded animated fadeInDown"
                  height="335"
                />
              </div>
              <div class="col-md-10 col-xl-8 card ml-n3 cards">
                <router-link to="/detail-product-service">
                 <h3 class="mt-4 text-dark text-center "><u>{{ $t('product.onSiteServices.heading') }}</u><br></h3>
                 <h3>
                   <span style="color: green;" class="font-weight-bold ml-5"> - {{ $t('product.onSiteServices.items.weldingOverlay') }}</span><br>
                   <span style="color: green;" class="font-weight-bold ml-5"> - {{ $t('product.onSiteServices.items.patching') }}</span><br>
                   <span style="color: green;" class="font-weight-bold ml-5"> - {{ $t('product.onSiteServices.items.piping') }}</span><br>
                   <span style="color: green;" class="font-weight-bold ml-5"> - {{ $t('product.onSiteServices.items.reShell') }}</span><br>
                   <span style="color: green;" class="font-weight-bold ml-5"> - {{ $t('product.onSiteServices.items.reTubing') }}</span><br>
                   <span style="color: green;" class="font-weight-bold ml-5"> - {{ $t('product.onSiteServices.items.shutdownMaintenance') }}</span><br>
                 </h3>
                 <!-- <p class="mt-4 text-dark">There are some reason build the site lorem ipsum dolor sit amet.</p> -->
                 <!-- <h6 style="color: orange; margin-top: 67px; margin-bottom: 38px;">READ MORE</h6> -->
                </router-link>
              </div>
            </div>
          <!-- </div> -->

      </div>
    </div>

    <div class="section mt-n4 mb-4">
      <div class="container">
        <!-- SECOND INTRODUCTION -->
        <div style="color: red:">
          <img
            src="img/product.png"
            alt="TEF products overview"
            class=" img-fluid"/>
        </div>
        <div style="color: red:" class="mt-5">
          <img
            src="img/exp_delivery.png"
            alt="TEF export and delivery experience"
            class=" img-fluid"/>
        </div>
        <div style="color: red:" class="mt-5">
          <img
            src="img/exp_material.png"
            alt="TEF material experience"
            class=" img-fluid"/>
        </div>
      </div>
    </div>

    <div class="section section-tabs text-center">
      <div class="">
        <!-- <h2 class="title">TERIMAKASIH KEPADA</h2> -->
        <!-- <h4>Major Customer in Indonesia</h4> -->
        <!-- <marquee style="font-weight: bold; margin-top: 0px; margin-bottom: 500px;" class="mt-0">
          <div style="white-space: nowrap;">
            <img width="190" class="mr-5" src="img/our_client/smelting.png" alt="Smelting logo" />
            <img width="280" class="mr-5" src="img/our_client/PKG.png" alt="PKG logo" />
            <img width="240" class="mr-5" src="img/our_client/pon.png" alt="PON logo" />
            <img width="580" class="mr-5" src="img/our_client/pja.png" alt="PJA logo" />
            <img width="350" class="mr-5" src="img/our_client/linde.png" alt="Linde logo" />
            <img width="470" class="mr-5" src="img/our_client/petrocental.png" alt="Petrocental logo" />
            <img width="380" class="mr-5" src="img/our_client/pnk.png" alt="PNK logo" />
            <img width="230" class="mr-5" src="img/our_client/tpc.png" alt="TPC logo" />
            <img width="230" class="mr-5" src="img/our_client/daesang.png" alt="Daesang logo" />
            <img width="780" class="mr-5" src="img/our_client/freeport.png" alt="Freeport logo" />
            <img width="380" class="mr-5" src="img/our_client/solvay.png" alt="Solvay logo" />
            <img width="380" class="mr-5" src="img/our_client/liku.png" alt="LIKU logo" />
            <img width="390" class="mr-5" src="img/our_client/wilmar.png" alt="Wilmar logo" />
            <img width="240" class="mr-5" src="img/our_client/ajg.png" alt="AJG logo" />
            <img width="330" class="mr-5" src="img/our_client/ote.png" alt="OTE logo" />
            <img width="290" class="mr-5" src="img/our_client/chiyoda.png" alt="Chiyoda logo" />
            <img width="220" class="mr-5" src="img/our_client/asuka.png" alt="Asuka logo" />
            <img width="220" class="mr-5" src="img/our_client/hti.png" alt="HTI logo" />
            <img width="190" class="mr-5" src="img/our_client/ajinomoto.png" alt="Ajinomoto logo" />
            <img width="180" class="mr-5" src="img/our_client/tjiwi.png" alt="Tjiwi logo" />
            <img width="750" class="mr-5" src="img/our_client/sindopex.png" alt="Sindopex logo" />
            <img width="450" class="mr-5" src="img/our_client/cj.png" alt="CJ logo" />
            <img width="430" class="mr-5" src="img/our_client/easternex.png" alt="Easternex logo" />
            <img width="170" class="mr-5" src="img/our_client/alp.png" alt="ALP logo" />
            <img width="190" class="mr-5" src="img/our_client/sasa.png" alt="SASA logo" />
            <img width="190" class="mr-5" src="img/our_client/indoperin.png" alt="Indoperin logo" />
            <img width="280" class="mr-5" src="img/our_client/tppi.png" alt="TPPI logo" />
            <img width="110" class="mr-5" src="img/our_client/htsi.png" alt="HTSI logo" />
            <img width="510" class="mr-5" src="img/our_client/jtrust.png" alt="Jtrust logo" />
          </div>
        </marquee> -->

        <h2 class="title">{{ $t('common.offices.ourHappyClient') }}</h2>
        <h4>{{ $t('common.offices.majorCustomerIn') }} Indonesia</h4>
        <marquee style="font-weight: bold; margin-top: 0px;" class="mt-5">
          <div style="white-space: nowrap;">
            <img height="90" class="mr-5" src="img/our_client/asahimas.png" alt="Asahimas logo" />
            <img height="90" class="mr-5" src="img/our_client/mcci.png" alt="MCCI logo" />
            <img height="90" class="mr-5" src="img/our_client/jfe.png" alt="JFE logo" />
            <img height="90" class="mr-5" src="img/our_client/sulfindo.png" alt="Sulfindo logo" />
            <img height="90" class="mr-5" src="img/our_client/pertamina.png" alt="Pertamina logo" />
            <img height="90" class="mr-5" src="img/our_client/pupuk.png" alt="Pupuk logo" />
            <img height="90" class="mr-5" src="img/our_client/smelting.png" alt="Smelting logo" />
            <img height="90" class="mr-5" src="img/our_client/sri.png" alt="SRI logo" />
            <img height="90" class="mr-5" src="img/our_client/statomer.png" alt="Statomer logo" />
            <img height="90" class="mr-5" src="img/our_client/nsi.png" alt="NSI logo" />
            <img height="90" class="mr-5" src="img/our_client/ineos.png" alt="Ineos logo" />
            <img height="90" class="mr-5" src="img/our_client/ikpt.png" alt="IKPT logo" />
            <img height="90" class="mr-5" src="img/our_client/lotte.png" alt="Lotte logo" />
            <img height="90" class="mr-5" src="img/our_client/loc.png" alt="LOC logo" />
            <img height="90" class="mr-5" src="img/our_client/hmm.png" alt="HMM logo" />
            <img height="90" class="mr-5" src="img/our_client/jgc.png" alt="JGC logo" />
            <img height="90" class="mr-5" src="img/our_client/chiyoda.png" alt="Chiyoda logo" />
            <img height="90" class="mr-5" src="img/our_client/lenzing.png" alt="Lenzing logo" />
            <img height="90" class="mr-5" src="img/our_client/star_energy.png" alt="STAR Energy logo" />
            <img height="90" class="mr-5" src="img/our_client/sankyu.png" alt="Sankyu logo" />
            <img height="90" class="mr-5" src="img/our_client/candra.png" alt="Candra logo" />
            <img height="90" class="mr-5" src="img/our_client/sumelectric.png" alt="Sumelectric logo" />
            <img height="90" class="mr-5" src="img/our_client/sunchirin.png" alt="Sunchirin logo" />
            <img height="90" class="mr-5" src="img/our_client/uic.png" alt="UIC logo" />
            <img height="90" class="mr-5" src="img/our_client/ajinomoto.png" alt="Ajinomoto logo" />
            <img height="90" class="mr-5" src="img/our_client/basf.png" alt="BASF logo" />
            <img height="90" class="mr-5" src="img/our_client/kao.png" alt="KAO logo" />
          </div>
        </marquee>
        <h4 class="mt-5">{{ $t('common.offices.majorCustomerIn') }} Japan</h4>
        <marquee style="font-weight: bold; margin-top: 0px;" class="mt-5">
          <div style="white-space: nowrap;">
            <img height="90" class="mr-5" src="img/our_client/toray.png" alt="Toray logo" />
            <img height="90" class="mr-5" src="img/our_client/tosoh.png" alt="Tosoh logo" />
            <img height="90" class="mr-5" src="img/our_client/idemitsu.png" alt="Idemitsu logo" />
            <img height="90" class="mr-5" src="img/our_client/sumchem.png" alt="Sumchem logo" />
            <img height="90" class="mr-5" src="img/our_client/ngk.png" alt="NGK logo" />
            <img height="90" class="mr-5" src="img/our_client/ak.png" alt="AK logo" />
            <img height="90" class="mr-5" src="img/our_client/kureha.png" alt="Kureha logo" />
            <img height="90" class="mr-5" src="img/our_client/jgc_jpy.png" alt="JGC JPY logo" />
            <img height="90" class="mr-5" src="img/our_client/chiyoda.png" alt="Chiyoda logo" />
            <img height="90" class="mr-5" src="img/our_client/sekisui.png" alt="Sekisui logo" />
            <img height="90" class="mr-5" src="img/our_client/onex.png" alt="ONEX logo" />
            <img height="90" class="mr-5" src="img/our_client/mcci.png" alt="MCCI logo" />
            <img height="90" class="mr-5" src="img/our_client/jfe.png" alt="JFE logo" />
          </div>
        </marquee>
        <h4 class="mt-5">{{ $t('common.offices.majorCustomerIn') }} Singapore</h4>
        <marquee style="font-weight: bold; margin-top: 0px;" class="mt-5">
          <div style="white-space: nowrap;">
            <img height="90" class="mr-5" src="img/our_client/pfizer.png" alt="Pfizer logo" />
            <img height="90" class="mr-5" src="img/our_client/msd.png" alt="MSD logo" />
            <img height="90" class="mr-5" src="img/our_client/astar.png" alt="Astar logo" />
            <img height="90" class="mr-5" src="img/our_client/src.png" alt="SRC logo" />
            <img height="90" class="mr-5" src="img/our_client/gsk.png" alt="GSK logo" />
            <img height="90" class="mr-5" src="img/our_client/shell.png" alt="Shell logo" />
            <img height="90" class="mr-5" src="img/our_client/sumcheas.png" alt="Sumcheas logo" />
          </div>
        </marquee>
        <h4 class="mt-5">{{ $t('common.offices.majorCustomerIn') }} Malaysia</h4>
        <marquee style="font-weight: bold; margin-top: 0px;" class="mt-5">
          <div style="white-space: nowrap;">
            <img height="90" class="mr-5" src="img/our_client/oleo.png" alt="OLEO logo" />
            <img height="90" class="mr-5" src="img/our_client/sumelectric.png" alt="Sumelectric logo" />
            <img height="90" class="mr-5" src="img/our_client/basf_petronas.png" alt="BASF Petronas logo" />
            <img height="90" class="mr-5" src="img/our_client/toray.png" alt="Toray logo" />
            <img height="90" class="mr-5" src="img/our_client/kao.png" alt="KAO logo" />
            <img height="90" class="mr-5" src="img/our_client/toyo.png" alt="TOYO logo" />
            <img height="90" class="mr-5" src="img/our_client/petronas.png" alt="Petronas logo" />
          </div>
        </marquee>
        <h4 class="mt-5">{{ $t('common.offices.majorCustomerIn') }} Thailand</h4>
        <marquee style="font-weight: bold; margin-top: 0px;" class="mt-5">
          <div style="white-space: nowrap;">
            <img height="90" class="mr-5" src="img/our_client/covestro.png" alt="Covestro logo" />
            <img height="90" class="mr-5" src="img/our_client/taniobis.png" alt="Taniobis logo" />
            <img height="90" class="mr-5" src="img/our_client/tpac.png" alt="TPAC logo" />
            <img height="90" class="mr-5" src="img/our_client/tpcc.png" alt="TPCC logo" />
            <img height="90" class="mr-5" src="img/our_client/prolific.png" alt="Prolific logo" />
            <img height="90" class="mr-5" src="img/our_client/kikai.png" alt="Kikai logo" />
            <img height="90" class="mr-5" src="img/our_client/agc.png" alt="AGC logo" />
            <img height="90" class="mr-5" src="img/our_client/surtec.png" alt="Surtec logo" />
            <img height="90" class="mr-5" src="img/our_client/jfe.png" alt="JFE logo" />
            <img height="90" class="mr-5" src="img/our_client/scg.png" alt="SCG logo" />
            <img height="90" class="mr-5" src="img/our_client/toshiba.png" alt="Toshiba logo" />
          </div>
        </marquee>
      </div>
    </div>

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}  :</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  methods: {
    // toDetailProduct(param){
    //   this.$router.push('/detail-product/'+param)
    // }
  }
};
</script>
<style>
   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }


  .cards:hover{
    box-shadow: 5px 6px 6px 2px #e9ecef;
    transform: scale(1.1);
    cursor: pointer;;
  }

.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
